import styled from 'styled-components';

export const SdgAlignmentWrapperStyled = styled.div`
  margin-top: 20px;

  ${({ theme }) => `
    ${theme.devices.mobile} {
      display: none;  
    }
  `}
`;

export const GoalIconsWrapperStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
  gap: 25px;
`;

export const CounterLabelStyled = styled.p`
  text-align: center;
  margin-bottom: 15px;

  ${({ theme }) => `
    font-size: ${theme.fontSizes.small};
    font-weight: ${theme.fontWeights.medium};
  `}
`;
